import "./TableDesign.css";
import { useState, useEffect, useRef } from "react";
import { regUses, useTblInfo, useTblDef, randomUUID} from "../../axios_with_token";
import {useForm} from "react-hook-form";
import { VAL_DELETED } from "../../consts";
import WWAccordion from "../../components/WWAccordion/WWAccordion";
import WWTabs from "../../components/WWTabs/WWTabs";
import ObjEdit from "../../widgets/ObjEdit/ObjEdit";
import ArrEdit from "../../widgets/ArrEdit/ArrEdit";
import { FldDefEdit } from "../../widgets/FldDefEdit/FldDefEdit";
import { getEditWgt, wgtSettings } from "../../widgets/widgets";

export const stdTblDef = {
    tblName: {

    },
    tblCaption: {
        
    },
    tblDescription: {

    },
    listView: {
        caption: 'list view',
        type:'select',
        src:[
            ['list', 'list'],
            ['tree', 'tree'],
            ['cards', 'cards']
        ],
        default: 'list'
    },
    tplCon:{
    },
    tplItem:{
    },
    listFlds:{
    },
    editTpl:{

    }
}

export function TblDefEdit({tblDef:tblDefIn, forms, pathIn}){
    const path = pathIn || "root";
    const [tblDef, setTblDef] = useState({...(tblDefIn||{})});
    const WrappedObjEdit = getEditWgt('objEdit');

    // [] preprocess
    return <div>
        {/* [] since TblDefEdit is used in JsonTblEdit, if use form may cause form embeded in form error */}
        <div role="form">
            <WWTabs
                tabDefs={[
                    {
                        caption: 'Base',
                        active: true,
                        Content: ({})=><div className="my-3">
                            <WrappedObjEdit
                                objTpl={stdTblDef}
                                fldVal={tblDef}
                                objVal={tblDef}

                                forms={forms}
                                path={path}
                            ></WrappedObjEdit>
                        </div>
                    },
                    {
                        caption: 'Fields',
                        Content:({})=><div>
                            <FldDefList
                                tblDef={tblDef}
                                fldDefEdits={{}}
                                
                                forms={forms}
                                path={[path, "inputSettings"].join(',')}
                            ></FldDefList>
                        </div>
                    },
                    {
                        caption: 'Embeds'
                    },
                    {
                        caption: 'Customized'
                    },
                ]}
            ></WWTabs>
        </div>
    </div>;
}

export function useTblDefEdit({tblName}){
    const {regUse, isReady, isLoading, getErrMsgs} = regUses();
    const {data:tblDefGot} = regUse(useTblDef(tblName));
    const tblDef = {...tblDefGot||{}};
    // {register, handleSubmit, formState:{errors}, setValue, unregister, getValues}
    // [] here the form is changed, but in component, the form is still used
    const forms = {};
    const path = "root";
    // [] none input settings

    useEffect(_=>{
        Object.keys(tblDef||{}).forEach(fldName=>delete tblDef[fldName]);
    }, [tblName])

    return {
        loading: isLoading(),
        error: getErrMsgs(),
        isReady: isReady(),
        Component: ({})=><TblDefEdit
            tblDef={tblDef}

            forms={forms}
            path={path}
        ></TblDefEdit>,

        forms,
        path
    }
}

// [] a special ObjEdit
export function FldDefList({tblDef:tblDefIn, form:formIn, defaultSettings, forms, path:pathIn}){

    const [tblDef, setTblDef] = useState(tblDefIn || {});
    const inputSettings = tblDef.inputSettings || {};

    const CompFldDefEdits = {};
    
    Object.keys(inputSettings).forEach(fldName=>{
        const path = [pathIn, fldName].join(',');
        const fldDef = inputSettings[fldName] || {};
        CompFldDefEdits[fldName] = ({})=><FldDefEdit
            fldName={path}
            fldDef={fldDef}

            fldVal={fldDef}
            objVal={fldDef}

            // form={form}
            defaultSettings={{
                caption:{},
                default:{},
                ...(defaultSettings||{})
            }}

            forms={forms}
            path={path}
        ></FldDefEdit>;

    });

    return <div className="my-3">
        <button type="button" className="btn btn-sm btn-primary"
            title="add field"
            onClick={evt=>{
                const newFldName = prompt("input new field name:");
                if(!newFldName)return;
                tblDef.inputSettings = tblDef.inputSettings || {};
                if(tblDef.inputSettings[newFldName]){
                    alert('field exists.')
                    return;
                }
                tblDef.inputSettings = tblDef.inputSettings || {};
                tblDef.inputSettings[newFldName] = {};
                setTblDef({...tblDef});
            }}
        >+</button>
        <WWAccordion
            itemDefs={Object.keys(tblDef.inputSettings || {}).map((fldName, fldIdx)=>{
                const fldDef = (tblDef.inputSettings || {})[fldName] || {};
                const FldDefEditReady = CompFldDefEdits[fldName] || (({})=><FldDefEdit
                    fldName={fldName}
                    fldDef={fldDef}
                    fldVal={fldDef}
                    // form={form}
                    defaultFlds={{
                        test: {}
                    }}

                    forms={forms}
                    path={pathIn}
                ></FldDefEdit>);
                return {
                    CaptionComp: ({})=><div
                        className="form-control me-3"
                    >
                        {fldIdx+1}. {fldName} ({fldDef.type||'input'})
                        <span className="btn btn-sm btn-primary ms-3 float-end"
                            onClick={evt=>{
                                const newTblDef = {...tblDef};
                                newTblDef.inputSettings = {...(newTblDef.inputSettings || {})};
                                delete newTblDef.inputSettings[fldName];
                                setTblDef(newTblDef);
                            }}
                        >X</span>
                    </div>,
                    Content: ({})=><FldDefEditReady></FldDefEditReady>
                };
            })}
        ></WWAccordion>
    </div>;
}

export default function TableDesign({}){
    const {regUse, isLoading, DefaultLoading, hasError, DefaultError, isReady, DefaultResponse} = regUses();
    const refData = useRef({
        init: false
    });

    const [tblName, setTblName] = useState("");
    const [tblList, setTblList] = useState([]);

    const {data:tblInfo} = regUse(useTblInfo());
    
    const {Component:TblDefEditReady, forms, path} = regUse(useTblDefEdit({tblName}));

    // const tblList = Object.keys(tblInfo||{});

    // [] load first tbl as initial
    useEffect(_=>{
        if(!refData.current.init && isReady()){
            refData.current.init = true;
            setTblList([...Object.keys(tblInfo||{}), ...tblList])

            const tblName = Object.keys(tblInfo||{})[0];
            if(tblName){
                // form.reset();
                // Object.keys(form.getValues()).forEach(fldName=>form.unregister(fldName));
                return _=>{
                    setTblName(tblName);
                }
            }
        }        
    })
    
    return <DefaultResponse>
        <h2>table design [{tblName}]</h2>
        <div className="container">
            <div className="row" style={{position:"relative"}}>
                <div className="col-md-3">
                    <div className="sticky-top" style={{top:"120px"}}>
                        <button className="form-control btn btn-primary"
                            type="button"
                            onClick={evt=>{
                                let newTblName;
                                if(newTblName = window.prompt("Please input the name for new table:")){
                                    if(tblList[newTblName]){
                                        alert(`tbl [${newTblName}] exists already.`)
                                    }else{
                                        const newTblList = {...tblList};
                                        newTblList[newTblName] = {};
                                        setTblList([...tblList, newTblName])
                                        setTblName(newTblName);

                                    }
                                }
                            }}
                        >add table</button>
                        <select
                            className="form-select"
                            defaultValue={tblName}
                            onChange={evt=>{
                                // form.reset();
                                setTblName(evt.target.value)
                            }}
                        >
                            {tblList.map((_tblName,idx)=><option key={_tblName}>{_tblName}</option>)}
                        </select>
                        <button className="form-control btn btn-primary"
                            type="button"
                            onClick={evt=>{
                                console.log('forms:', forms)
                                let val = {};
                                console.log('base:', Object.keys(forms), forms['root'].getValues())
                                Object.keys(forms).forEach(formName=>{
                                    const form = forms[formName];
                                    val = {...val, ...form.getValues()};
                                })
                                const valOut = {};
                                Object.keys(val).forEach(itemName=>{
                                    if(val[itemName] == VAL_DELETED)return;
                                    const itemNameSplited = itemName.split(',');
                                    let valLevel = valOut;
                                    for(let i=0, l=itemNameSplited.length-1; i<l; i++){
                                        valLevel[itemNameSplited[i]] = valLevel[itemNameSplited[i]] || (/^\d+$/.test(itemNameSplited[i])?[]:{});
                                        valLevel = valLevel[itemNameSplited[i]];
                                    }
                                    valLevel[itemNameSplited[itemNameSplited.length-1]] = val[itemName];
                                })
                                console.log('valOut:', valOut);
                            }}
                        >save</button>
                        <span>settings</span>
                    </div>                              
                </div>
                <div className="col-md-9">
                    <TblDefEditReady></TblDefEditReady>
                </div>
            </div>
        </div>
    </DefaultResponse>
}